import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { config } from "../../../config/global";
import { viewShoppingCartRequest, viewShoppingCartSuccess, viewShoppingCartFailure } from "../slice/shoppingCartSlice";
const headerData = {
  mode: "no-cors",
  headers: {
    "Content-Type": "application/json",
    "App-Authorization": localStorage.getItem("accesstoken") || ""
  },
  loader: true,
  isGenericErr: false
};
const API_VIEW_SHOPPING_CART = config.DAPI_BOOKING_SHOPPING_CART;
const viewShoppingCartData = async payload => {
  const response = await api.post(API_VIEW_SHOPPING_CART, payload, headerData);
  return response;
};
function* viewShoppingCart(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(viewShoppingCartData, payload);
    yield put(viewShoppingCartSuccess(response?.data));
  } catch (error) {
    yield put(viewShoppingCartFailure(error?.response?.data?.errors));
  }
}
export function* watchShoppingCartData() {
  yield takeLatest(viewShoppingCartRequest.type, viewShoppingCart);
}